import GroupsIcon from '@mui/icons-material/Groups';
import { Box, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import { useTranslation } from 'next-i18next';
import { StyledTokenIcon } from '@/components/ui/common/TokenIcon';
import { getUserReferReward } from '@/apis/casino/rush';
import { useQuery } from '@tanstack/react-query';
import { useLuckyPotSize } from '@/components/features/casino/rush/hooks';
import { formatMoneyByCurrency } from '@/utils';
import { isLoggedIn } from '@/state/userInfo';
import { useAtomValue } from 'jotai';
import { floorToN } from '@/components/features/casino/crash/GameBox/utils';

const useReferReward = (loggedIn) => {
  const { data } = useQuery({
    queryKey: ['rush', 'referReward'],
    queryFn: getUserReferReward,
    enabled: loggedIn,
  });
  return {
    currency: data ? data.currency : 'USDT',
    amount: data ? floorToN(Number(data.total), 2) : 0,
  };
};

const BonusText = styled(Typography)(({ theme }) => ({
  fontSize: '12px',
  color: theme.palette.text.help,
}));
export default function ReferralBonus() {
  const { t } = useTranslation();
  const loggedIn = useAtomValue(isLoggedIn);
  const { amount, currency } = useReferReward(loggedIn);
  const { isMobile } = useLuckyPotSize();

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        // pt: isMobile ? 1 : 2,
        visibility: loggedIn ? 'visible' : 'hidden',
        fontSize: '12px',
        whiteSpace: 'nowrap',
      }}
    >
      <GroupsIcon
        sx={{
          color: (theme) => theme.palette.text.help,
        }}
      />
      <BonusText sx={{ ml: 1 }}>{t('Referral Commission')}:&nbsp;</BonusText>
      <BonusText>
        {formatMoneyByCurrency(amount, { currency })}
        <StyledTokenIcon currency={currency} />{' '}
      </BonusText>
    </Box>
  );
}
